module.exports = __webpack_public_path__ + "static/media/walkthrough.87694621.png";